var exports = {
  "kL": "x31de4314--12835b--container",
  "Qs": "x31de4314--12835b--content",
  "Sl": "x31de4314--12835b--image",
  "DD": "x31de4314--12835b--title",
  "q9": "x31de4314--12835b--price",
  "h_": "x31de4314--12835b--description",
  "lT": "x31de4314--12835b--locationBlock",
  "C5": "x31de4314--12835b--location",
  "kB": "x31de4314--12835b--time",
  "NR": "x31de4314--12835b--locationIcon",
  "DB": "x31de4314--12835b--timeIcon",
  "fN": "x31de4314--12835b--locationText",
  "Tc": "x31de4314--12835b--timeText",
  "hl": "x31de4314--12835b--address",
};

module.exports = exports;
